export default "__VITE_ASSET__DhXytRjt__"